import React from "react";
import logoImage from "../../assets/logo.png";

interface MaintenancePageProps {
  message?: string | null;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ message }) => {
  return (
    <div className="min-h-screen bg-cvc-white flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white rounded-lg shadow-lg border border-cvc-grey px-8 py-10 sm:px-12">
          {/* Logo and Title Section */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-6">
              <img
                src={logoImage}
                alt="CVC"
                className="h-16 w-auto"
              />
            </div>
            <h1 className="font-cvcDisplay text-2xl font-bold text-cvc-blue mb-2">
              Deal<span className="font-normal">OS</span>
            </h1>
          </div>

          {/* Maintenance Icon */}
          <div className="flex justify-center mb-6">
            <svg
              className="w-16 h-16 text-cvc-orange"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>

          {/* Maintenance Message */}
          <div className="text-center space-y-4">
            <h2 className="font-cvcBody text-xl font-semibold text-cvc-text">
              System Under Maintenance
            </h2>
            <p className="font-cvcBody text-sm text-gray-600">
              {message || "We're currently performing scheduled maintenance. Please check back shortly."}
            </p>
          </div>

          {/* Contact Section */}
          <div className="mt-8 text-center">
            <p className="font-cvcBody text-xs text-gray-500">
              If you need immediate assistance, please contact{" "}
              <a
                href="mailto:ai@cvc.com"
                className="text-cvc-blue hover:text-cvc-marine transition-colors duration-200 underline"
              >
                ai@cvc.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
